import styles from './LoggedOutHome.module.css';

import { useEffect, useState } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import _ from 'underscore';

import { CardReveal } from '../../components/CardReveal';
import { Slide, SlideItem } from '../../components/Slide';

import { Button } from '../../components/Button';
import { HelmetComponent } from '../../components/Helmet';
import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';
import * as routes from './../../constants/Routes';
import { IBannerImage, IBanners, ISecondaryBanners } from './interfaces';
import { IAction } from '../../interfaces/IAction';

export function LoggedOutHome() {
  const { client, player } = useAuth();
  const navigate = useNavigate();

  const [banners, setBanners] = useState<Array<IBanners>>();
  const [bannerImages, setBannerImages] = useState<Array<IBannerImage>>();
  const [bannerImagesMobile, setBannerImagesMobile] =
    useState<Array<IBannerImage>>();
  const [actionsList, setActionsList] = useState<Array<IAction>>([]);
  const [filterActionList, setFilterActionList] = useState<Array<IAction>>([]);
  const [filterActionType, setFilterActionType] = useState<string>('');
  const [indexActiveFilter, setIndexActiveFilter] = useState<number>(0);
  const [secondaryBanners, setSecondaryBanners] =
    useState<Array<ISecondaryBanners>>();
  const [isLoadingActions, setIsLoadingActions] = useState<boolean>(true);
  const [isLoadingBanners, setIsLoadingBanners] = useState<boolean>(true);
  const [imagesActions, setImagesActions] = useState<any>();
  const [actionsImagesBase64, setActionsImagesBase64] = useState<Array<any>>(
    []
  );

  const filterPublicationsChoice =
    client?.filterPublicationsChoice === true ||
    client?.filterPublicationsChoice === 'true';

  useEffect(() => {
    getClientTerms();
    getActionsList();
    getClientBanners();
  }, []);

  useEffect(() => {
    let bannerImagesDesktop: Array<any> = [];
    let bannerImagesMobile: Array<any> = [];
    const secondaryBanners: any = banners?.filter(
      (banner) => !banner.isPrimary && banner.active
    );

    banners?.forEach((banner) => {
      if (banner.active && banner.bannerType.value !== 'Secundário') {
        if (banner.bannerImage) {
          bannerImagesDesktop = Object.values(banner.bannerImage).filter(
            (bannerMobile) => {
              bannerMobile.link = banner.link;
              return bannerMobile;
            }
          );
        }

        if (banner.bannerImageMobile) {
          bannerImagesMobile = Object.values(banner.bannerImageMobile).filter(
            (bannerMobile: any) => {
              bannerMobile.link = banner.link;
              return bannerMobile;
            }
          );
        }
      }
    });

    bannerImagesDesktop && setBannerImages(bannerImagesDesktop);
    bannerImagesMobile && setBannerImagesMobile(bannerImagesMobile);
    secondaryBanners && setSecondaryBanners(secondaryBanners);
  }, [banners]);

  useEffect(() => {
    const actionsFiltered: Array<any> = [];
    if (filterActionType !== '') {
      actionsList &&
        actionsList.length > 0 &&
        actionsList.forEach((action: any) => {
          if (
            action.actionType &&
            action.actionType.trim().includes(filterActionType.trim())
          ) {
            actionsFiltered.push(action);
          }
        });

      setFilterActionList(actionsFiltered);
    } else {
      setFilterActionList(actionsList);
    }
  }, [actionsList, filterActionType]);

  useEffect(() => {
    if (actionsList) {
      const imagesMap = actionsList.map((img) => {
        const images = img.images;
        const actionId = img.id;

        return { images, actionId };
      });

      setImagesActions(imagesMap);
    }
  }, [actionsList]);

  useEffect(() => {
    if (imagesActions) {
      const responseImagesActions = imagesActions.map(
        async (imgsAction: any) => {
          if (imgsAction.images) {
            const responseImgsBase64 = imgsAction.images.map(
              async (img: any) => {
                const imageUrl = img.url;
                const imgBase64 = await imageUrlToBase64(img.url);

                return {
                  imageUrl,
                  imgBase64,
                };
              }
            );

            const response = await Promise.all(responseImgsBase64);

            return { images: response, actionId: imgsAction.actionId };
          }
        }
      );

      Promise.all(responseImagesActions).then((response) =>
        setActionsImagesBase64(response)
      );
    }
  }, [imagesActions]);

  const imageUrlToBase64 = async (url: any): Promise<any> => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((onSuccess, onError) => {
      try {
        const reader = new FileReader();
        reader.onload = function () {
          onSuccess(this.result);
        };
        reader.readAsDataURL(blob);
      } catch (e) {
        onError(e);
      }
    });
  };

  const getClientTerms = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getClientTerms',
        userType: 'player',
        clientId: client && client.id,
      };

      await api.post('/search', parameters);
    } catch (error) {
      console.log('error getClientTerms-->', error);
    }
  };

  const getActionsList = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getClientActions',
        userType: 'player',
        clientId: client && client.id,
        playerId: player && player.id,
      };

      const { data } = await api.post(`/search`, parameters);

      if (data && data.data) {
        setActionsList(data.data.actions);
        setFilterActionList(data.data.actions);
      } else {
        setActionsList([]);
        setFilterActionList([]);
      }

      setIsLoadingActions(false);
    } catch (error) {
      console.log('error getActionsList-->', error);

      setIsLoadingActions(false);
      setActionsList([]);
      setFilterActionList([]);
    }
  };

  const getClientBanners = async () => {
    if (!client) return;

    try {
      const parameters = {
        searchFunctionality: 'loadBanners',
        userType: 'client',
        clientUid: client.id,
      };

      const data = await api.post(`/search`, parameters);

      const banners = data?.data?.data?.banners;

      if (banners) {
        setBanners(Object.values(banners));
        setIsLoadingBanners(false);
      }
    } catch (error) {
      console.log('error getClientBanners-->', error);
    }
  };

  const renderFilterActionType = () => {
    return (
      <div className="col-12 col-sm-12 col-md-6 mb-4">
        <select
          name="filterActionType"
          className={`${styles.select}`}
          value={filterActionType}
          onChange={(e) => setFilterActionType(e.target.value)}
        >
          <option value="">Filtrar por tipo</option>
          <option value="normal">Produto Único</option>
          <option value="combo">Combo</option>
          <option value="recurrent">Recorrente</option>
        </select>
      </div>
    );
  };

  const handleFilterPosts = () => {
    const arrActionsList = [...actionsList];
    const B = arrActionsList.filter(
      (e) => e.actionType !== 'quiz' && e.actionType !== 'researchAward'
    );
    setFilterActionList(B);
    setIndexActiveFilter(2);
  };

  const removeFilter = () => {
    const arrActionsList = [...actionsList];
    setFilterActionList(arrActionsList);
    setIndexActiveFilter(0);
  };

  const handleFilterQuiz = () => {
    const arrActionsList = [...actionsList];
    const B = arrActionsList.filter(
      (e) => e.actionType === 'quiz' || e.actionType === 'researchAward'
    );
    setFilterActionList(B);
    setIndexActiveFilter(1);
  };

  const handleFilterEvent = () => {
    const arrActionsList = [...actionsList];
    const B = arrActionsList.filter((e) => e.actionType === 'presential');
    setFilterActionList(B);
    setIndexActiveFilter(3);
  };

  // Limite aplicado também no adminzão (maxLength dos inputs)
  const filterTabLabel = (label?: string, fallback = '') =>
    (label?.trim() || fallback).slice(0, 20);

  const renderBtnsFilterChoice = () => {
    return (
      <div className="my-md-4 my-sm-0">
        <div className="row flex-column flex-md-row">
          <div className="col-12 col-md mb-3 mb-md-0">
            <div className="d-grid">
              <Button
                text="Ver todos"
                onClick={removeFilter}
                icon="label"
                color={indexActiveFilter === 0 ? 'flat' : undefined}
              />
            </div>
          </div>
          {client?.buttonFilterQuiz && (
            <div className="col-12 col-md mb-3 mb-md-0">
              <div className="d-grid">
                <Button
                  text={filterTabLabel(client?.buttonFilterQuiz)}
                  onClick={handleFilterPosts}
                  icon="label"
                  color={
                    indexActiveFilter && indexActiveFilter === 2
                      ? 'flat'
                      : undefined
                  }
                />
              </div>
            </div>
          )}

          {client?.buttonFilterAction && (
            <div className="col-12 col-md mb-3 mb-md-0">
              <div className="d-grid">
                <Button
                  text={filterTabLabel(client?.buttonFilterAction)}
                  onClick={handleFilterQuiz}
                  icon="label"
                  color={
                    indexActiveFilter && indexActiveFilter === 1
                      ? 'flat'
                      : undefined
                  }
                />
              </div>
            </div>
          )}

          <div className="col-12 col-md mb-3 mb-md-0">
            <div className="d-grid">
              <Button
                text={filterTabLabel(
                  client?.buttonFilterRegister,
                  'Presencial'
                )}
                onClick={handleFilterEvent}
                icon="label"
                color={
                  indexActiveFilter && indexActiveFilter === 3
                    ? 'flat'
                    : undefined
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSecondaryBanner = () => {
    return (
      secondaryBanners &&
      secondaryBanners.length > 0 &&
      secondaryBanners.map((banner, index) => {
        return (
          <div key={index} className="col-sm-12 col-md-6 ">
            <div className="d-flex align-items-center justify-content-center mb-3">
              <a href={banner.link || ''} target="_blank">
                {typeof banner.bannerImage === 'string' ? (
                  <img
                    key={banner.bannerImage}
                    className="img-fluid rounded-3"
                    src={banner.bannerImage}
                    alt=""
                  />
                ) : (
                  <>
                    {_.map(banner.bannerImage, (bannerImage, i) => {
                      return (
                        <img
                          key={i}
                          src={
                            typeof bannerImage.url === 'string'
                              ? bannerImage.url
                              : ''
                          }
                          className="img-fluid rounded-3"
                          alt=""
                        />
                      );
                    })}
                  </>
                )}
              </a>
            </div>
          </div>
        );
      })
    );
  };

  const renderSecondaryBannerInfluencer = () => {
    const secondaryBanners = banners?.filter(
      (banner) => !banner.isPrimary && banner.active
    );

    const influencer = player && player.influencer;

    return (
      secondaryBanners &&
      secondaryBanners.map((banner, index) => {
        if (
          (banner &&
            (banner.userType.value === 'influencers' ||
              banner.userType.value === 'todos') &&
            influencer === true) ||
          (banner &&
            (banner.userType.value === 'players' ||
              banner.userType.value === 'todos') &&
            !influencer)
        ) {
          return (
            <div key={index} className="col-12 col-sm-12 col-md-6 col-lg-4">
              <div className="form-group">
                <a href={banner.link || ''} target="_blank">
                  {typeof banner.bannerImage === 'string' ? (
                    <img
                      key={banner.bannerImage}
                      className="img-fluid banner-center banner-secondary"
                      src={banner.bannerImage}
                      alt=""
                    />
                  ) : (
                    <>
                      {_.map(banner.bannerImage, (bannerImage, i) => {
                        return (
                          <img
                            key={i}
                            className="img-fluid banner-center banner-secondary"
                            src={
                              i !== 'url' ? bannerImage.url : bannerImage.url
                            }
                            alt=""
                          />
                        );
                      })}
                    </>
                  )}
                </a>
              </div>
            </div>
          );
        }
      })
    );
  };

  const renderAction = (action: IAction) => {
    if (action.actionType === 'researchAward') {
      return (
        <CardReveal
          key={action.id}
          idProps={action.id}
          action={action}
          frame={action.videoURL !== '' ? action.videoURL : false}
          image={
            action.files && action.files.image1
              ? action.files.image1
              : String(action.images[0])
          }
          title={action.callToAction}
          ctaText={action.callActionText}
          client={client}
          player={player}
          isInteract={player && player.acceptedTerms}
        />
      );
    }

    if (action.actionType === 'quiz') {
      return (
        <CardReveal
          key={action.id}
          idProps={action.id}
          action={action}
          frame={action.videoURL !== '' ? action.videoURL : false}
          image={
            action.images && action.images.length > 0
              ? action.images[0].url
              : ''
          }
          title={action.callToAction}
          ctaText={action.callActionText}
          client={client}
          player={player}
          isInteract={player && player.acceptedTerms}
        />
      );
    }

    if (action.images && action.images.length === 1 && action.videoURL !== '') {
      return (
        <CardReveal
          key={action.id}
          idProps={action.id}
          action={action}
          title={action.callToAction}
          client={client}
          player={player}
          actionImagesBase64={actionsImagesBase64}
          isInteract={player && player.acceptedTerms}
        />
      );
    }

    if (action.images && action.images.length > 1 && action.videoURL === '') {
      return (
        <CardReveal
          key={action.id}
          idProps={action.id}
          action={action}
          image={action.images[0].url}
          title={action.callToAction}
          client={client}
          player={player}
          actionImagesBase64={actionsImagesBase64}
          isInteract={player && player.acceptedTerms}
        />
      );
    }

    if (action.images && action.images.length === 1 && action.videoURL === '') {
      return (
        <CardReveal
          key={action.id}
          idProps={action.id}
          action={action}
          image={action.images[0].url}
          title={action.callToAction}
          client={client}
          player={player}
          actionImagesBase64={actionsImagesBase64}
          isInteract={player && player.acceptedTerms}
        />
      );
    }

    if (action.images && action.images.length > 1 && action.videoURL !== '') {
      return (
        <CardReveal
          key={action.id}
          idProps={action.id}
          action={action}
          title={action.callToAction}
          client={client}
          player={player}
          actionImagesBase64={actionsImagesBase64}
          isInteract={player && player.acceptedTerms}
        />
      );
    }
  };

  const firstAction = filterActionList.find((action) => action.isFirstAction);
  const remainingActionList = firstAction
    ? filterActionList.filter((action) => action.id !== firstAction.id)
    : filterActionList;

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Home'}
      />

      {/* Skeleton do banner */}
      {isLoadingBanners && (
        <div className="my-3">
          <Skeleton height={400} />
        </div>
      )}
      {/* fim Skeleton do banner */}
      {/* Banners renderizados */}
      {!isLoadingBanners && (
        <BrowserView>
          <div className="mt-3">
            <Slide>
              {bannerImages &&
                bannerImages.map((banner, index) => (
                  <SlideItem
                    key={banner.url}
                    image={banner.url}
                    active={index === 0 ? true : false}
                    bannerLink={banner.link}
                  />
                ))}
            </Slide>
          </div>
        </BrowserView>
      )}
      {!isLoadingBanners && (
        <MobileView>
          <div className="mt-3">
            <Slide>
              {bannerImagesMobile &&
                bannerImagesMobile.map((banner, index) => (
                  <SlideItem
                    key={banner.url}
                    image={banner.url}
                    active={index === 0 ? true : false}
                    bannerLink={banner.link}
                  />
                ))}
            </Slide>
          </div>
        </MobileView>
      )}
      {/* fim Banners renderizados */}
      {/* Skeleton das publicações */}
      {isLoadingActions && (
        <div className="my-3">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-4">
              <Skeleton height={240} />
              <div className="my-3">
                <Skeleton />
                <Skeleton height={40} />
              </div>
              <div className="row">
                <div className="col">
                  <Skeleton height={40} />
                </div>
                <div className="col">
                  <Skeleton height={40} />
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4">
              <Skeleton height={240} />
              <div className="my-3">
                <Skeleton />
                <Skeleton height={40} />
              </div>
              <div className="row">
                <div className="col">
                  <Skeleton height={40} />
                </div>
                <div className="col">
                  <Skeleton height={40} />
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4">
              <Skeleton height={240} />
              <div className="my-3">
                <Skeleton />
                <Skeleton height={40} />
              </div>
              <div className="row">
                <div className="col">
                  <Skeleton height={40} />
                </div>
                <div className="col">
                  <Skeleton height={40} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* fim Skeleton das publicações */}
      {/* Actions renderizadas */}
      {!isLoadingActions && (
        <>
          <div className="my-3">
            {player && !player.acceptedTerms && (
              <>
                <div className="p-3 text-center">
                  <p className="fs-3">Cadastro incompleto</p>
                  <p>
                    Você precisa completar seu cadastro para poder
                    visualizar/resgatar as premiações disponíveis no programa.
                    Por favor, vá até seu perfil e complete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Button
                      text="Completar cadastro"
                      color="primary"
                      onClick={() => {
                        navigate(routes.EDIT_PROFILE);
                      }}
                    />
                  </div>
                </div>
              </>
            )}
            {client &&
              client.filterChoice === 'true' &&
              filterPublicationsChoice &&
              renderBtnsFilterChoice()}
            {client && client.clientUrl === 'emr' && renderFilterActionType()}
            <div className="row g-4">
              {firstAction && renderAction(firstAction)}
              {remainingActionList &&
                remainingActionList.map((action) => {
                  return renderAction(action);
                })}
            </div>
          </div>
          {(client && !client.isTeamCompetition) ||
            (client && client.isTeamCompetition === 'false' && (
              <>
                {secondaryBanners && secondaryBanners.length > 0 && (
                  <div className="d-flex align-items-center mb-3">
                    <i className="material-icons-outlined me-3 color-text">
                      turned_in_not
                    </i>
                    <span className="fs-4">Mais para você</span>
                  </div>
                )}
                <div className="row">{renderSecondaryBanner()}</div>
              </>
            ))}
          {client &&
            client.isTeamCompetition &&
            client.isTeamCompetition === 'true' && (
              <div className="row g-4">{renderSecondaryBannerInfluencer()}</div>
            )}
        </>
      )}
      {/* fim Actions renderizadas */}
    </>
  );
}
